export default "__VITE_ASSET__CuFpXNaP__"